import { render } from "./HomeMenu.vue?vue&type=template&id=7dcf8940"
import script from "./HomeMenu.vue?vue&type=script&lang=js"
export * from "./HomeMenu.vue?vue&type=script&lang=js"

import "./HomeMenu.vue?vue&type=style&index=0&id=7dcf8940&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__